import RecentTransactionGrid from "shared/components/projectHeadComponents/transaction/recentTransactionGrid";
import TransactionGraph from "shared/components/projectHeadComponents/transaction/transactionGraph";
import StatsCard from "shared/components/statsCard";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import { routeConstant } from "shared/routes/routesConstant";
import styles from "./style.module.scss";
import { useState } from "react";
import FullScreenStatsCard from "../../shared/components/projectHeadComponents/transaction/fullScreenTabs";

function PhNewTransaction() {
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [openFullScreen, setOpenFullScreen] = useState<boolean>(false);

  let statsCard = [
    {
      label: "Total Income",
      count: 4736782,
      stats: {
        index: true,
        difference: "10%",
      },
    },
    {
      label: "Active Subscriptions",
      count: 1147300,
      stats: {
        index: false,
        difference: "2%",
      },
    },
    {
      label: "Lost Subscriptions",
      count: 877625,
      stats: {
        index: true,
        difference: "5%",
      },
    },
  ];

  useBreadcrumbs({
    title: "Transactions",
    path: routeConstant?.projectHeadTransactions?.path,
  });

  return (
    <div className={styles.mainContainer}>
      <StatsCard
        statsList={statsCard}
        label={"Income Stats"}
        isDateRequired={true}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
      />
      <TransactionGraph
        isFullScreenRequired={true}
        openFullScreen={openFullScreen}
        setOpenFullScreen={setOpenFullScreen}
      />
      <RecentTransactionGrid />
      <FullScreenStatsCard
        label={"Income Stats"}
        open={openFullScreen}
        handleClose={() => {
          setOpenFullScreen(false);
        }}
      />
    </div>
  );
}

export default PhNewTransaction;
